import { LoadingOverlay } from '@eventbrite/eds-loading-overlay';
import React, { FunctionComponent } from 'react';
import LogoMarkToCheckbox from '../../resources/logoMarkToCheckbox';
import { getLoadingOverlayStyle } from '../../utils/rebrand';
import rebrandStyles from './LoadingPage.rebranding.module.scss';

export const LoadingPage: FunctionComponent<{
    isAppRebrandActive: boolean;
}> = ({ isAppRebrandActive }) => {
    const styles = isAppRebrandActive ? rebrandStyles : {};

    return isAppRebrandActive ? (
        <div className={styles?.wrapperLoadingAnimation}>
            <LogoMarkToCheckbox
                endFrame={80}
                isAppRebrandActive={isAppRebrandActive}
            />
        </div>
    ) : (
        <LoadingOverlay
            isShown={true}
            style={getLoadingOverlayStyle(isAppRebrandActive)}
            isAppRebrandActive={isAppRebrandActive}
        />
    );
};

export default LoadingPage;
